module.exports = __webpack_public_path__ + "img/laying-diagonale.4a31d378.svg";